import { Link as RouterLink } from "react-router-dom";
import { Add, EditOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  CardActions,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useGetAllOfficesQuery } from "app/api/offices";
import { useState } from "react";
import { Office } from "models/Office";
import UpsertOfficeDialog from "../dialogs/UpsertOfficeDialog";
import ErrorDisplay from "components/ErrorDisplay";
import LoadingDisplay from "components/LoadingDisplay";

const OfficesSection: React.FC = () => {
  const { data: offices, isLoading, error } = useGetAllOfficesQuery();

  const [isUpsertDialogOpen, setIsUpsertDialogOpen] = useState(false);
  const [officeToEdit, setOfficeToEdit] = useState<Office | null>(null);

  if (isLoading) return <LoadingDisplay message="Laddar kontor..." />;
  if (error) return <ErrorDisplay message="Fel vid hämtning av kontor" />;

  return (
    <>
      {offices?.length && (
        <List disablePadding>
          {offices?.map((office) => (
            <ListItem
              key={office.id}
              divider
              secondaryAction={
                <IconButton
                  onClick={() => {
                    setOfficeToEdit(office);
                    setIsUpsertDialogOpen(true);
                  }}
                >
                  <EditOutlined />
                </IconButton>
              }
            >
              <ListItemText
                primary={office.name}
                secondary={
                  <>
                    <Typography fontSize="inherit">Medlemmar: {office.membersCount}</Typography>
                    <Typography fontSize="inherit">
                      Ordergranskare:{" "}
                      {office.orderReviewer ? (
                        <Link
                          component={RouterLink}
                          to={`/users/view/${office.orderReviewer.userId}`}
                        >
                          {office.orderReviewer.userName}
                        </Link>
                      ) : (
                        "Ingen"
                      )}
                    </Typography>
                  </>
                }
                slotProps={{ primary: { fontWeight: "bold" }, secondary: { component: Box } }}
              />
            </ListItem>
          ))}
        </List>
      )}

      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Add />}
          onClick={() => {
            setOfficeToEdit(null);
            setIsUpsertDialogOpen(true);
          }}
        >
          Nytt kontor
        </Button>
      </CardActions>

      {isUpsertDialogOpen && (
        <UpsertOfficeDialog
          office={officeToEdit}
          onClose={() => {
            setIsUpsertDialogOpen(false);
            setOfficeToEdit(null);
          }}
        />
      )}
    </>
  );
};

export default OfficesSection;
